import { useRouter } from '@tanstack/react-router';

const useRouterNavigation = () => {
  const router = useRouter();
  return {
    back: () => {
      if (window.history.state.__TSR_index > 0) {
        router.history.back();
      } else {
        router.navigate({ to: '/inbox' });
      }
    },
  };
};

export default useRouterNavigation;
